import React from "react";
import { Space } from "antd";
import type { ApplicationSummaryBlockProps, ApplicationSummaryProps } from "./types";
import ApplicationGeneralInfo from "./blocks/ApplicationGeneralInfo";
import CargoCharacteristics from "./blocks/CargoCharacteristics";
import DangerousCargoInfo from "./blocks/DangerousCargoInfo";
import TransportationDetails from "./blocks/TransportationDetails";
import PaymentTerms from "./blocks/PaymentTerms";
import ApplicationDocuments from "./blocks/ApplicationDocuments";

export type { ApplicationSummaryProps } from "./types";

const noopApplicationChange: ApplicationSummaryBlockProps["onChange"] = () => undefined;

const ApplicationSummary = React.memo(
  ({
    application,
    onChange = noopApplicationChange,
    canEditApplicationFields = false,
    canEditApplicationComment = false,
    onCommit,
  }: ApplicationSummaryProps) => {
    const blockProps: ApplicationSummaryBlockProps = { application, onChange, canEditApplicationFields, onCommit };

    return (
      <Space orientation="vertical" style={{ width: "100%" }}>
        <ApplicationGeneralInfo {...blockProps} canEditApplicationComment={canEditApplicationComment} />
        <CargoCharacteristics {...blockProps} />
        <DangerousCargoInfo {...blockProps} />
        <TransportationDetails {...blockProps} />
        <PaymentTerms {...blockProps} />
        <ApplicationDocuments {...blockProps} />
      </Space>
    );
  },
);

export default ApplicationSummary;
